<template>
  <div
    class="category-item"
    v-for="item of FEATURED_LIST"
    :key="item.name"
    @click="onItemClick(item)"
  >
    {{ item.label[language.current] }}
  </div>
</template>

<script setup>
import { FEATURED_LIST } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const emit = defineEmits(['click'])
const router = useRouter()

const language = useLanguageStore()

const onItemClick = (item) => {
  router.push(item.path)
  emit('click', item)
}
</script>

<style lang="less" scoped>
@hoverColor: #009de0;

.category-item {
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 24px;
  padding: 4px 8px;
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  font-family: mon-500;

  &:hover {
    color: @hoverColor;
    font-weight: 500;
  }
}
</style>
